module.exports = __webpack_public_path__ + "static/media/feedback-bw-neg.516442f6.svg";